__turbopack_context__.v({
  "accordion": "SearchFilterAccordions-module-scss-module__NdSgTW__accordion",
  "checkbox": "SearchFilterAccordions-module-scss-module__NdSgTW__checkbox",
  "checkbox-control": "SearchFilterAccordions-module-scss-module__NdSgTW__checkbox-control",
  "checkbox-group": "SearchFilterAccordions-module-scss-module__NdSgTW__checkbox-group",
  "checkbox-indicator": "SearchFilterAccordions-module-scss-module__NdSgTW__checkbox-indicator",
  "checkboxes-wrapper": "SearchFilterAccordions-module-scss-module__NdSgTW__checkboxes-wrapper",
  "clear-button": "SearchFilterAccordions-module-scss-module__NdSgTW__clear-button",
  "clear-button-icon": "SearchFilterAccordions-module-scss-module__NdSgTW__clear-button-icon",
  "content": "SearchFilterAccordions-module-scss-module__NdSgTW__content",
  "filter-item": "SearchFilterAccordions-module-scss-module__NdSgTW__filter-item",
  "group-title": "SearchFilterAccordions-module-scss-module__NdSgTW__group-title",
  "indicator": "SearchFilterAccordions-module-scss-module__NdSgTW__indicator",
  "input": "SearchFilterAccordions-module-scss-module__NdSgTW__input",
  "input-root": "SearchFilterAccordions-module-scss-module__NdSgTW__input-root",
  "input-wrapper": "SearchFilterAccordions-module-scss-module__NdSgTW__input-wrapper",
  "main": "SearchFilterAccordions-module-scss-module__NdSgTW__main",
  "slide-down": "SearchFilterAccordions-module-scss-module__NdSgTW__slide-down",
  "slide-up": "SearchFilterAccordions-module-scss-module__NdSgTW__slide-up",
  "trigger": "SearchFilterAccordions-module-scss-module__NdSgTW__trigger",
  "trigger-icon": "SearchFilterAccordions-module-scss-module__NdSgTW__trigger-icon",
});
